/* eslint-disable no-unused-vars */
import React, { useEffect } from "react";
// import { BackIcon, CloseIcon } from "../../../components/Icons";
import { StyledBookingFlowButton } from "../../containers/BookingScheduleContainer/BookingScheduleContainer.style";
import { useBookingAppointmentTypeStore } from "../../../hooks";
import { useAppointmentStore } from "../../../hooks/redux-hooks/appointment-store/appointment.store";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useModal } from "../../../context/ModalContext";
import ClearIcon from "@mui/icons-material/Clear";
import { MODALS } from "../../../config/params";
import { useCancelAndAddAppointment } from "../../../services/appointment/appointment-update-cancel-service";


const RescheduleDropOffModal = () => {
  const { setDefaultBookingType } = useBookingAppointmentTypeStore();
  const { selectedPets } = useAppointmentStore();
  const { setAppointmentsForm } = useAppointmentStore();
  const { closeModal, openModal } = useModal();
  const { updateAndCancelAppointment, appointmentone } = useCancelAndAddAppointment();


  const handleNormalBookingSelection = ()=>{
    setDefaultBookingType();
    setAppointmentsForm(null);
    openModal(MODALS.RESCHEDULE_A_VISIT);
  };

  const handleConfirmDropOff = ()=>{
    updateAndCancelAppointment();
  };

  const handleBackClick = ()=>{
    openModal(MODALS.RESCHEDULE_A_VISIT);
  };

  useEffect(() => {
    if (appointmentone) {
      if (appointmentone.success === false) {
        closeModal();

        return;
      }
      openModal(MODALS.UPDATED_BOOKING_CONFIRMATION_MODAL);
    }
  }, [appointmentone]);

  return (
    <div className="flex flex-col justify-between h-full">
      <div className="flex justify-between w-full px-2 pt-1">
        <div>
          {
            <ArrowBackIcon onClick={handleBackClick} className="text-light-black cursor-pointer" />}
        </div>
        <span onClick={closeModal} > <ClearIcon className="cursor-pointer" /></span>
      </div>

      <div className="flex items-center h-full">
        <div className="">
          <div>
            <img
              className="max-h-44 max-w-44 mx-auto"
              alt="confirm_dropoff_icon"
              src="/assets/icons/Confirm_dropoff.svg"
            />
          </div>
          <div className="text-2xl font-bold text-center mt-2">
            Confirm Drop-Off Appointment
          </div>
          <p className="text-light-black text-center mt-1.5">
            You’ll be leaving{" "}
            {
              selectedPets && selectedPets.length > 0 &&
              selectedPets.map((pet, index)=>(
                <>
                  <span className="capitalize" key={index}>
                    {pet.name}
                    {index !== (selectedPets.length - 1) && index !== (selectedPets.length - 2) && ", "}
                  </span>
                  <span>{index === (selectedPets.length - 2) && " and "}</span>
                </>
              ))
            }
            {" "}with us, and enjoy flexible pickup times. Our care team will
            be available to answer any questions during drop-off and pickup.
          </p>
        </div>
      </div>
      <div className="space-y-3 text-center">
        <StyledBookingFlowButton
          color="primary"
          size="small"
          className="w-full"
          onClick={handleConfirmDropOff}
        >
          Confirm Drop-Off
        </StyledBookingFlowButton>
        <StyledBookingFlowButton
          onClick={handleNormalBookingSelection}
          color="primary"
          size="small"
          className="!bg-transparent !border !border-light-black !text-black w-full hover:!bg-gray-3"
        >
          Doctor Visit Instead
        </StyledBookingFlowButton>
      </div>
    </div>
  );
};

export default RescheduleDropOffModal;
